import { BasePostInputModel } from "../../../../../models/http/InputModel/BasePostInputModel"
import { ApiUserData } from "src/models/user/ApiUserData"

export type UserToUserIdCommissionPostParams = {
  user: ApiUserData
  requestReasonId: number
  wishItemId: number
  wishItemMessage: string
  giftItemId: string
  amount: number
}

export class UserToUserIdCommissionPostInputModel extends BasePostInputModel {
  constructor(private params: UserToUserIdCommissionPostParams) {
    super()
  }

  get pathParams() {
    return {
      to_user_id: this.params.user.id.toString(),
    }
  }
  get body() {
    return {
      request_reason_id: this.params.requestReasonId,
      wish_item_id: this.params.wishItemId,
      wish_item_message: this.params.wishItemMessage,
      gift_item_id: this.params.giftItemId,
      amount: this.params.amount,
    }
  }
}
